
export default function TourFormat({ title, children }) {
    return (
      <div className="the-format">
        <h4 className="the-title px-5 py-4 text-center">{title}</h4>
        <div className="the-format-container"> {children} </div>
      </div>
    );
  }